<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>富文本编辑器</span>
      </div>
      <el-button-group>
        <el-button
          :type="
            sysConfig['base.editor'] === 'CKEditor5' ? 'primary' : 'default'
          "
          @click="changeEditor('CKEditor5')"
        >CKEditor5</el-button>
        <el-button
          :type="
            sysConfig['base.editor'] === 'WangEditor' ? 'primary' : 'default'
          "
          @click="changeEditor('WangEditor')"
        >wangEditor</el-button>
        <el-button
          :type="
            sysConfig['base.editor'] === 'UEditorPlus' ? 'primary' : 'default'
          "
          @click="changeEditor('UEditorPlus')"
        >UEditorPlus</el-button>
      </el-button-group>
      <div class="tips">
        <div><span class="label">CKEditor5：</span>新版本编辑器，只支持新特性浏览器，对内容编辑体验较好，推荐使用。</div>
        <div><span class="label">WangEditor：</span>国产优质富文本编辑器，对于小程序及App内容支持会更友好，推荐使用。</div>
        <div><span class="label">UEditorPlus：</span>基于 UEditor 二次开发的富文本编辑器</div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SysConfig',
  computed: {
    ...mapGetters(['sysConfig'])
  },
  methods: {
    changeEditor(editor) {
      if (this.sysConfig['base.editor'] === editor) {
        return
      }
      this.$store.dispatch('sys_config/updateConfig', {
        type: 'base',
        name: 'editor',
        value: editor
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tips {
  padding: 20px 0 0;
  font-size: 12px;
  line-height: 1.5;
  .label {
    font-weight: bold;
  }

  > div {
    padding: 5px 0;
  }
}
</style>
